module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_pets-31cddc3f3ac10fb221121e329be94957.jpg";